import { Avatar } from 'avatar-components';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalUserAvatar(props) {
  const {
    approvalUser
  } = props;
  const {
    email
  } = approvalUser;
  return /*#__PURE__*/_jsx(Avatar, {
    "data-test-id": "approval-user-avatar",
    size: "md",
    hubSpotUserEmail: approvalUser.email,
    displayName: email
  });
}
export default ApprovalUserAvatar;